import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useParams,
} from "react-router-dom";
import Login from "@/pages/auth/Login";
import DocLinkDash from "@/pages/doclink/DocLinkDash";
import DocLinkAnalyticsPage from "@/pages/doclink/DocLinkAnalyticsPage";
import QudaDash from "@/pages/quda/QudaDash";
import QudaAnalyticsPage from "@/pages/quda/QudaAnalyticsPage";
import ChemistAnalytics from "@/pages/shared/ChemistAnalytics";
// import ChemistData from "./pages/ChemistData";
import Overview from "@/pages/shared/Overview";
import Subscriptions from "@/pages/admin/Subscriptions";
import Admin from "@/pages/admin/Admin";
import GroupManagersPage from "@/pages/admin/GroupManagersPage";
import HubMedAdminLayout from "@/pages/admin/hubmed/HubMedAdminLayout";
import ZephyrAdminLayout from "@/pages/zephyr/ZephyrAdminLayout";
import ZephyrOverviewPage from "@/pages/zephyr/ZephyrOverviewPage";
import ZephyrInvoicesPage from "@/pages/zephyr/ZephyrInvoicesPage";
import ZephyrCustomersPage from "@/pages/zephyr/ZephyrCustomersPage";
import ZephyrPaymentsPage from "@/pages/zephyr/ZephyrPaymentsPage";
import ZephyrChemistsPage from "@/pages/zephyr/ZephyrChemistsPage";
import ZephyrOverdueInvoicesPage from "@/pages/zephyr/ZephyrOverdueInvoicesPage";
import ZephyrToolsPage from "@/pages/zephyr/ZephyrToolsPage";
import ZephyrProcessingPage from "@/pages/zephyr/ZephyrProcessingPage";
import ZephyrBankReconPage from "@/pages/zephyr/ZephyrBankReconPage";
import ZephyrStatementsPage from "@/pages/zephyr/ZephyrStatementsPage";
import HubMedAdminOverviewPage from "@/pages/admin/hubmed/HubMedAdminOverviewPage";
import HubMedOnboardingPage from "@/pages/admin/hubmed/HubMedOnboardingPage";
import HubMedPricingSettingsPage from "@/pages/admin/hubmed/HubMedPricingSettingsPage";
import HubMedLinkingPage from "@/pages/admin/hubmed/HubMedLinkingPage";
import HubMedPractitionerSettingsPage from "@/pages/admin/hubmed/HubMedPractitionerSettingsPage";
import HubMedReportsPage from "@/pages/admin/hubmed/HubMedReportsPage";
import HolaAdminLayout from "@/pages/admin/hola/HolaAdminLayout";
import HolaAdminOverviewPage from "@/pages/admin/hola/HolaAdminOverviewPage";
import HolaReportsPage from "@/pages/admin/hola/HolaReportsPage";
import MedmateAdminLayout from "@/pages/admin/medmate/MedmateAdminLayout";
import MedmateAdminOverviewPage from "@/pages/admin/medmate/MedmateAdminOverviewPage";
import MedmateLinkingPage from "@/pages/admin/medmate/MedmateLinkingPage";
import MedmateReportsPage from "@/pages/admin/medmate/MedmateReportsPage";
import AdminOverviewPage from "@/pages/admin/functions/AdminOverviewPage";
import AdminQudaPage from "@/pages/admin/functions/AdminQudaPage";
import AdminDocLinkPage from "@/pages/admin/functions/AdminDocLinkPage";
import AdminHaloPayPage from "@/pages/admin/functions/AdminHaloPayPage";
import AdminHaloTextPage from "@/pages/admin/functions/AdminHaloTextPage";
import AdminMediDropPage from "@/pages/admin/functions/AdminMediDropPage";
import AdminWebbitPage from "@/pages/admin/functions/AdminWebbitPage";
import AdminZephyrClaimsPage from "@/pages/admin/functions/AdminZephyrClaimsPage";
import AdminChemistPage from "@/pages/admin/functions/AdminChemistPage";
import AdminReportsPage from "@/pages/admin/functions/AdminReportsPage";
import AdminTrialHealthPage from "@/pages/admin/functions/AdminTrialHealthPage";
import AdminInactiveTerminalsPage from "@/pages/admin/functions/AdminInactiveTerminalsPage";
import AdminCherubPage from "@/pages/admin/functions/AdminCherubPage";
import AdminChemLinkPage from "@/pages/admin/functions/AdminChemLinkPage";
import AdminDialpadDashboardPage from "@/pages/admin/functions/AdminDialpadDashboardPage";
import AdminDialpadUnallocatedPage from "@/pages/admin/functions/AdminDialpadUnallocatedPage";
import AdminDialpadUsersPage from "@/pages/admin/functions/AdminDialpadUsersPage";
import AdminCalendlyPage from "@/pages/admin/functions/AdminCalendlyPage";
import ConferencesPage from "./pages/admin/functions/ConferencesPage";
import ConferenceDetailPage from "./pages/admin/functions/ConferenceDetailPage";
import WorkflowLayout from "@/pages/workflow/WorkflowLayout";
import OnboardingBoard from "@/pages/workflow/OnboardingBoard";
import GroupDealsBoard from "@/pages/workflow/GroupDealsBoard";
import JobBoard from "@/pages/workflow/JobBoard";
import ResetPassword from "@/pages/auth/ResetPassword";
import validateToken from "./services/authService";
import { getDefaultAuthenticatedHomePath } from "./services/adminAuthority";
import Loading from "@/components/feedback/Loading";
import Layout from "@/components/layout/Layout";

// Forces AdminChemistPage to fully remount when chemistUUID changes,
// so all tab data is re-fetched for the new chemist.
const KeyedAdminChemistPage = () => {
  const { chemistUUID } = useParams();
  return <AdminChemistPage key={chemistUUID} />;
};

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);

  useEffect(() => {
    const checkToken = async () => {
      console.log("=== Authentication Check ===");
      console.log("LocalStorage contents:", Object.keys(localStorage));
      console.log("jwtToken exists:", !!localStorage.getItem('jwtToken'));
      console.log("googleUserInfo exists:", !!localStorage.getItem('googleUserInfo'));
      console.log("userData exists:", !!localStorage.getItem('userData'));
      
      const isValid = await validateToken();
      console.log("Token validation result:", isValid);
      setIsAuthenticated(isValid);
    };

    checkToken();
  }, []);

  if (isAuthenticated === null) {
    return <Loading />;
  }

  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            isAuthenticated ? (
              <Navigate to={getDefaultAuthenticatedHomePath()} replace />
            ) : (
              <Login setIsAuthenticated={setIsAuthenticated} />
            )
          }
        />
        <Route
          path="/overview"
          element={
            isAuthenticated ? (
              <Layout setIsAuthenticated={setIsAuthenticated}>
                <Overview />
              </Layout>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/quda"
          element={
            isAuthenticated ? (
              <Layout setIsAuthenticated={setIsAuthenticated}>
                <QudaDash setIsAuthenticated={setIsAuthenticated} />
              </Layout>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/doclink"
          element={
            isAuthenticated ? (
              <Layout setIsAuthenticated={setIsAuthenticated}>
                <DocLinkDash setIsAuthenticated={setIsAuthenticated} />
              </Layout>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/subs"
          element={
            isAuthenticated ? (
              <Layout setIsAuthenticated={setIsAuthenticated}>
                <Subscriptions setIsAuthenticated={setIsAuthenticated} />
              </Layout>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/admin"
          element={
            isAuthenticated ? (
              <Layout setIsAuthenticated={setIsAuthenticated}>
                <Admin />
              </Layout>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/admin/group-managers"
          element={
            isAuthenticated ? (
              <Layout setIsAuthenticated={setIsAuthenticated}>
                <GroupManagersPage />
              </Layout>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/hubmed-admin"
          element={
            isAuthenticated &&
            (sessionStorage.getItem("IsHubMedAdmin") === "true" ||
              sessionStorage.getItem("IsPHAdmin") === "true") ? (
              <Layout setIsAuthenticated={setIsAuthenticated}>
                <HubMedAdminLayout />
              </Layout>
            ) : (
              <Navigate to={isAuthenticated ? getDefaultAuthenticatedHomePath() : "/"} replace />
            )
          }
        >
          <Route index element={<Navigate to="overview" replace />} />
          <Route path="overview" element={<HubMedAdminOverviewPage />} />
          <Route path="onboarding" element={<HubMedOnboardingPage />} />
          <Route
            path="practitioner-settings"
            element={<HubMedPractitionerSettingsPage />}
          />
          <Route
            path="pricing-settings"
            element={<HubMedPricingSettingsPage />}
          />
          <Route path="hubmed-linking" element={<HubMedLinkingPage />} />
          <Route path="reports" element={<HubMedReportsPage />} />
          <Route
            path="chemist-settings"
            element={<Navigate to="/hubmed-admin/pricing-settings" replace />}
          />
        </Route>
        <Route
          path="/hola-admin"
          element={
            isAuthenticated &&
            (sessionStorage.getItem("IsHolaAdmin") === "true" ||
              sessionStorage.getItem("IsPHAdmin") === "true") ? (
              <Layout setIsAuthenticated={setIsAuthenticated}>
                <HolaAdminLayout />
              </Layout>
            ) : (
              <Navigate to={isAuthenticated ? getDefaultAuthenticatedHomePath() : "/"} replace />
            )
          }
        >
          <Route index element={<Navigate to="overview" replace />} />
          <Route path="overview" element={<HolaAdminOverviewPage />} />
          <Route path="reports" element={<HolaReportsPage />} />
        </Route>
        <Route
          path="/medmate-admin"
          element={
            isAuthenticated &&
            (sessionStorage.getItem("IsMedmateAdmin") === "true" ||
              sessionStorage.getItem("IsPHAdmin") === "true") ? (
              <Layout setIsAuthenticated={setIsAuthenticated}>
                <MedmateAdminLayout />
              </Layout>
            ) : (
              <Navigate to={isAuthenticated ? getDefaultAuthenticatedHomePath() : "/"} replace />
            )
          }
        >
          <Route index element={<Navigate to="overview" replace />} />
          <Route path="overview" element={<MedmateAdminOverviewPage />} />
          <Route path="medmate-linking" element={<MedmateLinkingPage />} />
          <Route path="reports" element={<MedmateReportsPage />} />
        </Route>
        <Route
          path="/admin-functions/overview"
          element={
            isAuthenticated ? (
              <Layout setIsAuthenticated={setIsAuthenticated}>
                <AdminOverviewPage />
              </Layout>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/admin-functions/quda"
          element={
            isAuthenticated ? (
              <Layout setIsAuthenticated={setIsAuthenticated}>
                <AdminQudaPage />
              </Layout>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/admin-functions/doclink"
          element={
            isAuthenticated ? (
              <Layout setIsAuthenticated={setIsAuthenticated}>
                <AdminDocLinkPage />
              </Layout>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/admin-functions/halopay"
          element={
            isAuthenticated ? (
              <Layout setIsAuthenticated={setIsAuthenticated}>
                <AdminHaloPayPage />
              </Layout>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/admin-functions/halotext"
          element={
            isAuthenticated ? (
              <Layout setIsAuthenticated={setIsAuthenticated}>
                <AdminHaloTextPage />
              </Layout>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/admin-functions/medidrop"
          element={
            isAuthenticated ? (
              <Layout setIsAuthenticated={setIsAuthenticated}>
                <AdminMediDropPage />
              </Layout>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/admin-functions/webbit"
          element={
            isAuthenticated ? (
              <Layout setIsAuthenticated={setIsAuthenticated}>
                <AdminWebbitPage />
              </Layout>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/admin-functions/chem-link"
          element={
            isAuthenticated ? (
              <Layout setIsAuthenticated={setIsAuthenticated}>
                <AdminChemLinkPage />
              </Layout>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/admin-functions/zephyr-claims"
          element={
            isAuthenticated ? (
              <Layout setIsAuthenticated={setIsAuthenticated}>
                <AdminZephyrClaimsPage />
              </Layout>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/admin-functions/chemist/:chemistUUID"
          element={
            isAuthenticated ? (
              <Layout setIsAuthenticated={setIsAuthenticated}>
                <KeyedAdminChemistPage />
              </Layout>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/admin-functions/reports"
          element={
            isAuthenticated ? (
              <Layout setIsAuthenticated={setIsAuthenticated}>
                <AdminReportsPage />
              </Layout>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/admin-functions/trial-health"
          element={
            isAuthenticated ? (
              <Layout setIsAuthenticated={setIsAuthenticated}>
                <AdminTrialHealthPage />
              </Layout>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/admin-functions/inactive-terminals"
          element={
            isAuthenticated ? (
              <Layout setIsAuthenticated={setIsAuthenticated}>
                <AdminInactiveTerminalsPage />
              </Layout>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/admin-functions/cherub"
          element={
            isAuthenticated ? (
              <Layout setIsAuthenticated={setIsAuthenticated}>
                <AdminCherubPage />
              </Layout>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/admin-functions/dialpad/dashboard"
          element={
            isAuthenticated ? (
              <Layout setIsAuthenticated={setIsAuthenticated}>
                <AdminDialpadDashboardPage />
              </Layout>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/admin-functions/dialpad/unallocated"
          element={
            isAuthenticated ? (
              <Layout setIsAuthenticated={setIsAuthenticated}>
                <AdminDialpadUnallocatedPage />
              </Layout>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/admin-functions/dialpad/admin-users"
          element={
            isAuthenticated ? (
              <Layout setIsAuthenticated={setIsAuthenticated}>
                <AdminDialpadUsersPage />
              </Layout>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/admin-functions/calendly"
          element={
            isAuthenticated ? (
              <Layout setIsAuthenticated={setIsAuthenticated}>
                <AdminCalendlyPage />
              </Layout>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/admin-functions/conferences"
          element={
            isAuthenticated ? (
              <Layout setIsAuthenticated={setIsAuthenticated}>
                <ConferencesPage />
              </Layout>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/admin-functions/conferences/:id"
          element={
            isAuthenticated ? (
              <Layout setIsAuthenticated={setIsAuthenticated}>
                <ConferenceDetailPage />
              </Layout>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/doclink-analytics/:chemistID"
          element={
            isAuthenticated ? (
              <Layout setIsAuthenticated={setIsAuthenticated}>
                <DocLinkAnalyticsPage setIsAuthenticated={setIsAuthenticated} />
              </Layout>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/quda-analytics/:chemistID"
          element={
            isAuthenticated ? (
              <Layout setIsAuthenticated={setIsAuthenticated}>
                <QudaAnalyticsPage setIsAuthenticated={setIsAuthenticated} />
              </Layout>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/chemist/:chemistID"
          element={
            isAuthenticated ? (
              <Layout setIsAuthenticated={setIsAuthenticated}>
                <ChemistAnalytics setIsAuthenticated={setIsAuthenticated} />
              </Layout>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/manager-functions/overview"
          element={
            isAuthenticated ? (
              <Layout setIsAuthenticated={setIsAuthenticated}>
                <AdminOverviewPage isManager />
              </Layout>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/manager-functions/quda"
          element={
            isAuthenticated ? (
              <Layout setIsAuthenticated={setIsAuthenticated}>
                <AdminQudaPage isManager />
              </Layout>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/manager-functions/doclink"
          element={
            isAuthenticated ? (
              <Layout setIsAuthenticated={setIsAuthenticated}>
                <AdminDocLinkPage isManager />
              </Layout>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/manager-functions/halopay"
          element={
            isAuthenticated ? (
              <Layout setIsAuthenticated={setIsAuthenticated}>
                <AdminHaloPayPage isManager />
              </Layout>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/manager-functions/halotext"
          element={
            isAuthenticated ? (
              <Layout setIsAuthenticated={setIsAuthenticated}>
                <AdminHaloTextPage isManager />
              </Layout>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/manager-functions/medidrop"
          element={
            isAuthenticated ? (
              <Layout setIsAuthenticated={setIsAuthenticated}>
                <AdminMediDropPage isManager />
              </Layout>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/manager-functions/chemist/:chemistUUID"
          element={
            isAuthenticated ? (
              <Layout setIsAuthenticated={setIsAuthenticated}>
                <AdminChemistPage isManager />
              </Layout>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        {/* Zephyr Admin — standalone layout (no shared Layout wrapper) */}
        <Route
          path="/zephyr-admin"
          element={
            isAuthenticated ? (
              <ZephyrAdminLayout setIsAuthenticated={setIsAuthenticated} />
            ) : (
              <Navigate to="/" />
            )
          }
        >
          <Route index element={<Navigate to="overview" replace />} />
          <Route path="overview"    element={<ZephyrOverviewPage />} />
          <Route path="processing"  element={<ZephyrProcessingPage />} />
          <Route path="invoices"  element={<ZephyrInvoicesPage />} />
          <Route path="customers" element={<ZephyrCustomersPage />} />
          <Route path="payments"  element={<ZephyrPaymentsPage />} />
          <Route path="chemists"  element={<ZephyrChemistsPage />} />
          <Route path="overdue"   element={<ZephyrOverdueInvoicesPage />} />
          <Route path="statements" element={<ZephyrStatementsPage />} />
          <Route path="tools"     element={<ZephyrToolsPage />} />
          <Route path="bank-recon" element={<ZephyrBankReconPage />} />
        </Route>

        <Route
          path="/workflow"
          element={
            isAuthenticated ? (
              <Layout setIsAuthenticated={setIsAuthenticated}>
                <WorkflowLayout />
              </Layout>
            ) : (
              <Navigate to="/" />
            )
          }
        >
          <Route index element={<Navigate to="job-board" replace />} />
          <Route path="onboarding" element={<OnboardingBoard />} />
          <Route path="group-deals" element={<GroupDealsBoard />} />
          <Route path="job-board" element={<JobBoard />} />
        </Route>

        <Route path="/reset-password" element={<ResetPassword />} />
        {/* <Route path="/loading" element={<Loading />} />  */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
};

export default App;
